import { createSelector } from 'reselect';

const getHasLoaded = createSelector(
  (state) => state.findWordsStepOneExtraLevels.hasLoaded,
  (hasLoaded) => hasLoaded
);
const getCurrencyData = createSelector(
  (state) => state.findWordsStepOneExtraLevels.data.currency,
  (currency = {}) => currency
);
const getLevelsData = createSelector(
  (state) => state.findWordsStepOneExtraLevels.data.findWordsStepOneExtraLevels,
  (levels = []) => levels
);

export default {
  getCurrencyData,
  getHasLoaded,
  getLevelsData,
};
